<template>
    <transition name="fade">
        <div
            v-show="true"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            :class="[
                'absolute bottom-full left-1/2 mb-4 -translate-x-1/2 transform rounded-md border border-theme-border bg-theme-bg px-3 py-2 text-sm group-hover:block',
                allowWrap ? 'min-w-[200px] max-w-md' : 'whitespace-nowrap',
            ]"
        >
            <slot></slot>
            <svg-icon
                icon="tooltip_arrow"
                class="absolute bottom-[-17px] left-1/2 -translate-x-1/2 transform text-theme-bg"
            />
        </div>
    </transition>
</template>
<script>
export default {
    props: {
        allowWrap: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
